import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import CEODesk from "../components/CEODesk";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const CEODeskPage = () => {
  return (
    <>
      <Helmet>
        <title>CEO's Desk | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Welcome to the CEO’s Desk at TimeWatch Infocom, where innovation meets leadership. Our CEO shares insights on the company’s vision for pioneering biometric solutions, advanced access control systems, and smart security technologies. With a focus on excellence, reliability, and customer satisfaction, TimeWatch Infocom is committed to providing cutting-edge security solutions such as entrance automation, parking management, and time attendance systems. Learn about our leadership's dedication to shaping the future of security technology and fostering growth within the industry."
        />
        <link rel="canonical" href="https://www.timewatchindia.com/ceo-desk" />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="ceodesk">
          <CEODesk />
        </section>
      </div>
      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default CEODeskPage;
